export class Tier {
    price: String = '';
    quantity: String = '';
    icon: Number = 0;
    soldOut: Object = {};
}



// WEBPACK FOOTER //
// ./src/app/tier.ts